import { toRRuleString } from "../build-rule.js";
import { JS_DAY_TO_ICS, parseRRule } from "../parse-rule.js";
import type { RuleInput } from "../types.js";

/**
 * Recompute a rule's BYDAY/BYMONTHDAY anchor against a new date. Returns the
 * resulting RRULE string. Used when a "this and following" override moves the
 * series to a different weekday or day-of-month — the override carries this
 * fresh RRULE so segment expansion past the boundary follows the new shape.
 *
 * UNTIL is dropped from the output (overrides don't cap; the base rule does).
 */
export function recomputeShapedRrule(rrule: string, anchor: Date): string {
  const input = parseRRule(rrule);
  delete (input as Partial<RuleInput>).until;
  if (input.byDay && input.byDay.length > 0) {
    const code = JS_DAY_TO_ICS[anchor.getDay()];
    if (code) input.byDay = [code];
  }
  if (input.byMonthDay) input.byMonthDay = anchor.getDate();
  return toRRuleString(input);
}
